import React from 'react';
import './NotificationFullScreen.scss';
import AppContext from '../../../AppContext';
import { CustomWrapper } from '../CustomWrapper/CustomWrapper';
import SvgSelector from '../SvgSelector/SvgSelector';

interface Props {
  message: string
  close?: () => void
}

export const NotificationFullScreen: React.FC<Props> = ({ close = undefined, message }) => {
  const appContext = React.useContext(AppContext);

  return (
    <CustomWrapper backgroundOpacity={4} zIndex={1000}>
      <div className="NotificationFullScreen">
        <div className="NotificationFullScreenMessageBlock">
          <SvgSelector id="notificationWarning" />
          <h1>{message}</h1>
        </div>
        <div className="NotificationFullScreenBtns">
          <button
            type="button"
            onClick={() => {
              close && close();
              appContext!.setNotificationData(undefined);
            }}
          >
            OK
          </button>
        </div>
      </div>
    </CustomWrapper>
  );
};
